import { render, staticRenderFns } from "./ConfigurationList.vue?vue&type=template&id=0d03d3b6&scoped=true&"
import script from "./ConfigurationList.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d03d3b6",
  null
  
)

export default component.exports